import RentalYieldCard from "./RentalYieldCard";

const RentalYieldCardContainer = ({ calculation }: { calculation: any }) => {
  return <RentalYieldCard calculation={calculation} />;
};

export default RentalYieldCardContainer;
